import { useQuery } from '@tanstack/react-query';

import {
  type SuggestedSearches,
  type SuggestedSearchesQuery,
  SuggestedSearchesSchema,
} from '@mai/types';

import { apiClient } from './axios';

import { logger } from '@utils/logger';

export const useSuggestedSearchesQuery = (
  params: SuggestedSearchesQuery,
  enabled: boolean,
) => {
  return useQuery({
    queryKey: ['suggested-searches', params],
    queryFn: async () => {
      const response = await apiClient.get<SuggestedSearches>(
        '/suggested-searches',
        { params },
      );
      const validatedData = SuggestedSearchesSchema.safeParse(response.data);
      if (!validatedData.success) {
        logger.warn('failed to validate suggested searches data', {
          error: validatedData.error,
        });
        return response.data;
      }
      return validatedData.data;
    },
    enabled,
  });
};
